import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-client';
import type {
  Location,
  LocationType,
  PaginatedResponse,
} from '@/lib/types';

export interface LocationFilters {
  page?: number;
  page_size?: number;
  type?: LocationType | '';
  q?: string;
  ordering?: string;
}

export interface LocationWithAssetCount extends Location {
  asset_count?: number;
}

export function useLocations(filters: LocationFilters = {}) {
  const cleanFilters = Object.fromEntries(
    Object.entries(filters).filter(([, value]) => value !== '' && value !== undefined)
  );

  return useQuery({
    queryKey: queryKeys.locations.list(cleanFilters),
    queryFn: async (): Promise<PaginatedResponse<LocationWithAssetCount>> => {
      const response = await apiClient.get<PaginatedResponse<LocationWithAssetCount>>(
        '/api/v1/cf-locations/',
        { params: cleanFilters }
      );
      return response.data;
    },
  });
}

export function useLocation(id: number) {
  return useQuery({
    queryKey: queryKeys.locations.detail(id),
    queryFn: async (): Promise<LocationWithAssetCount> => {
      const response = await apiClient.get<LocationWithAssetCount>(`/api/v1/cf-locations/${id}/`);
      return response.data;
    },
    enabled: id > 0,
  });
}
